export default "__VITE_ASSET__DI1kyGRl__"